import { createFileRoute } from '@tanstack/react-router';
import { InboxPage } from '@/features/metric-hub/inbox/InboxPage';
import { useTrackSkillOnDwell } from '@/features/metric-hub/onboarding/use-skill-tracker';

function InboxRoute() {
  useTrackSkillOnDwell('check_inbox');
  return <InboxPage />;
}

export const Route = createFileRoute('/_authed/metric-hub/inbox')({
  component: InboxRoute,
});
